import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Headline from './headline';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #F1F3F8;
  min-height: 240px;

  ${props => props.theme.isMobileOrTablet && `
    min-height: 130px;
    margin-top: 0;
  `};

  ${props => props.theme.isMobile && `
    min-height: 103px;
  `};
`;

export default function Hero({ headlineGrab, activeFeatures }) {
  const isPremiumHeadlineGrabEnabled = _.includes(activeFeatures, 'premium_headline_grab');
  return (
    <Container>
      {!!isPremiumHeadlineGrabEnabled && !!headlineGrab && (
        <Headline headlineGrab={headlineGrab} />
      )}
    </Container>
  );
}

Hero.propTypes = {
  headlineGrab: PropTypes.string,
  activeFeatures: PropTypes.arrayOf(PropTypes.string),
};
Hero.defaultProps = {
  headlineGrab: null,
  activeFeatures: [],
};
